import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { Component } from "react";
import { Animated } from "react-animated-css";
import { Container, Row, Col } from "reactstrap";
import Navbar from "./Navbar";
import Portfolio from "./Portfolio";
import SliderGlide from "./SliderGlide";
import Footer from "./Footer";

class FoodGallery extends Component {
  render() {
    return (
      <div>
        <Animated
          animationInDelay={100}
          animationIn="bounceInLeft"
          animationOut="bounceInRight"
          isVisible
        >
          <Navbar />
        </Animated>
        <SliderGlide />

        <Container>
          <Row>
            <Col xs="4">
              <Animated
                animationInDelay={100}
                animationIn="slideInRight"
                animationOut="fadeOut"
                isVisible
              >
                <img
                  src={require("./tastysinsbyari.jpeg")}
                  style={imgStyle}
                  className="rounded float-right m-5"
                  alt=""
                />
              </Animated>
            </Col>
          </Row>
        </Container>
        <div class="b b-- b--fw">
          <div class="b-c">
            <div class="sh ">
              <h2 class="sh-title">Gallery</h2>
            </div>
          </div>
        </div>
        <Portfolio />
        <Footer />
      </div>
    );
  }
}

const imgStyle = {
  width: "89%",
  height: "85%",
};

export default FoodGallery;
